export const buildLanguageUrl = (targetLangCode) => {
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    
    const urlParams = new URLSearchParams(currentSearch);
    
    urlParams.set("lang", targetLangCode);
    
    const newSearch = urlParams.toString();
    
    return currentPath + (newSearch ? `?${newSearch}` : "");
};